import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Validators, Editor, Toolbar, schema } from 'ngx-editor';
import { toDoc, toHTML } from 'ngx-editor';
// TODO Rename and put in its own module

@Component({
  selector: 'dl-rich-text-document',
  templateUrl: './rich-text-document.component.html',
  styleUrls: ['./rich-text-document.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RichTextDocumentComponent implements OnInit, OnDestroy {
  public editor: Editor;
  public toolbar: Toolbar = [['bold', 'italic', 'underline'], ['ordered_list', 'bullet_list'], ['link']];
  public jsonDoc;
  public keyupFlagstatus = false;

  private _jsonTextItem: any = '';
  public _showInEditorItem = '';
  @Input()
  public get jsonTextItem(): any {
    return this._jsonTextItem;
  }
  public set jsonTextItem(jsonTextItemP: any) {
    this._jsonTextItem = jsonTextItemP;
    this.getHTMLTextFromJSON();
  }

  @Input()
  public get showInEditor(): string {
    return this._showInEditorItem;
  }
  public set showInEditor(edP: string) {
    this._showInEditorItem = edP;
    this.getHTMLTextFromJSON();
  }

  @Output() public jsonTextReturn = new EventEmitter<any>();

  public edform = new FormGroup({
    editorContent: new FormControl({ value: this._jsonTextItem, disabled: false }, Validators.required())
  });

  public get doc(): AbstractControl {
    return this.edform.get('editorContent');
  }

  public ngOnInit(): void {
    this.editor = new Editor();
    this.edform.get('editorContent').valueChanges.subscribe(chValue => {
      if (typeof chValue === 'string') {
        this.jsonDoc = toDoc(chValue, schema);
      } else {
        this.jsonDoc = chValue;
      }
      this.getUpdatedText();
    });
  }

  public getUpdatedText(): void {
    this.jsonTextReturn.emit(this.jsonDoc);
  }

  public getHTMLTextFromJSON(): void {
    this.edform.patchValue({
      editorContent: this._jsonTextItem
    });

    if (this.showInEditor === 'template') {
      this.edform.get('editorContent').disable();
    } else {
      this.edform.get('editorContent').enable();
    }
  }

  public editorkeydownEvent(evt) {
    this.keyupFlagstatus = true;
    this.getUpdatedText();
  }
  public ngOnDestroy(): void {
    this.editor.destroy();
  }
}
